import { parseJwt } from "@connect/post-message/jwt";
import * as z from "zod/mini";
import type { BuyCheckTokenPayload } from "./buy-check-token.types";

const nonEmptyString = z.string().check(z.minLength(1));

const claims = {
  type: z.literal("buy_check"),
  params: z.looseObject({
    quoteSignature: z.optional(nonEmptyString),
    transactionId: z.optional(nonEmptyString),
    externalTransactionId: z.optional(nonEmptyString),
    nextChallenge: z.optional(
      z.looseObject({
        type: nonEmptyString,
        params: z.optional(z.record(z.string(), z.unknown())),
      }),
    ),
  }),
  iat: z.optional(z.number()),
  exp: z.optional(z.number()),
};

const buyCheckTokenSchema = z.union([
  z.looseObject({ ...claims, iss: z.literal("dev-platform") }),
  z.looseObject({ ...claims, issuer: z.literal("dev-platform") }),
]);

export function decodeBuyCheckToken(token: string): BuyCheckTokenPayload | null {
  const result = z.safeParse(buyCheckTokenSchema, parseJwt(token));
  return result.success ? result.data : null;
}
